import type { RootState, SetState } from '../store';

export type RotatingZoneTitleSliceProps = {
    rotatingZoneTitle: {
        displayedTitleByZone: Record<string, string>;
        setDisplayedTitle: (zoneUid: string, title: string) => void;
        clearDisplayedTitle: (zoneUid: string) => void;
    };
};

export const rotatingZoneTitleSlice = ({ set, get }: SetState<RootState>): RotatingZoneTitleSliceProps => ({
    rotatingZoneTitle: {
        displayedTitleByZone: {},

        setDisplayedTitle: (zoneUid: string, title: string) => {
            if (!zoneUid || get().rotatingZoneTitle.displayedTitleByZone[zoneUid] === title) {
                return;
            }

            set(
                (state) => ({
                    rotatingZoneTitle: {
                        ...state.rotatingZoneTitle,
                        displayedTitleByZone: {
                            ...state.rotatingZoneTitle.displayedTitleByZone,
                            [zoneUid]: title
                        }
                    }
                }),
                false,
                'rotatingZoneTitle/setDisplayedTitle'
            );
        },

        clearDisplayedTitle: (zoneUid: string) => {
            if (!zoneUid || !(zoneUid in get().rotatingZoneTitle.displayedTitleByZone)) {
                return;
            }

            set(
                (state) => {
                    const next = { ...state.rotatingZoneTitle.displayedTitleByZone };
                    delete next[zoneUid];

                    return {
                        rotatingZoneTitle: {
                            ...state.rotatingZoneTitle,
                            displayedTitleByZone: next
                        }
                    };
                },
                false,
                'rotatingZoneTitle/clearDisplayedTitle'
            );
        }
    }
});
